export default "__VITE_ASSET__bWBvlsd___"